export default __webpack_public_path__ + "static/media/5popup.90250c2e.jpg";